<template>
  <div class="h-[37px] border border-osn-grey-03 rounded-full flex items-center">
    <svg-icon name="filter"
              size="20"
              class="ml-[12px]"></svg-icon>
    <el-select
        v-model="filter"
        @change="filterChange"
        class="filter-dropdown"
        clearable
        placeholder="排序"
        popper-class="filter-option"
    >
      <el-option
          v-for="item in filterOption"
          :key="item.value"
          :label="`${item.label}`"
          :value="item.value"
      >
        <span class="text-osn-dark-grey-00 font-normal">{{ item.label }}</span>

      </el-option>

    </el-select>
  </div>
</template>
<script setup>

import {computed, onMounted, onUnmounted, ref} from 'vue'
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useSearchWithStore} from "@/composables/useSearchWithStore";

const searchQueryStore = useSearchQueryStore()
const {handleSearchWithStore} = useSearchWithStore()


// 價格排序一律用 all_price:依 hourly/daily_price 排序時後端會排除沒有該價格的場地(8→7→5),
// all_price 每個場地都有,排序只會重排不會讓場地消失。
const PRICE_SORT_KEY = 'all_price'

const filter = ref('')
const filterOption = computed(() => {
  const priceFilterValue = PRICE_SORT_KEY;

  return [
    {
      label: '推薦排序',
      value: 'recommend-1',
    },
    {
      label: '上架日期 (由新到舊)',
      value: 'created_date-1',
    },
    {
      label: '價格 (由低到高)',
      value: priceFilterValue + '-0',
    },
    {
      label: '價格 (由高到低)',
      value: priceFilterValue + '-1',
    },
    {
      label: '坪數 (由小到大)',
      value: 'room_size-0',
    },
    {
      label: '坪數 (由大到小)',
      value: 'room_size-1',
    },
  ];
});


onMounted(() => {
  // todo 有需要清除，單獨清除sort就好
  // searchQueryStore.clearPagination()

  let {sort, dir} = searchQueryStore.getPagination;

  // sort 為空時預設顯示「推薦排序」
  if (!sort) {
    filter.value = 'recommend-1';
    return;
  }

  // 判斷排序方式是否包含 'price' 沒有就用 sort(舊的 hourly/daily_price 一併收斂成 all_price)
  filter.value = sort.includes('price')
      ? `${PRICE_SORT_KEY}-${dir}`
      : `${sort}-${dir}`;

  // 初始化 filter 時檢查是否存在於 filterOption 中，若不存在則使用預設值
  const filterExists = filterOption.value.some(option => option.value === filter.value);

  if (!filterExists) {
    filter.value = '';
  }

})
onUnmounted(() => {
  // searchQueryStore.clearPagination()
})

function parseFilter(value) {
  if (!value) {
    return
  }

  const [sortKey, dir] = value.split('-');
  const dirNum = Number(dir);

  return {
    // 推薦排序 = 後端預設排序(sort 留空)
    sort: sortKey === 'recommend' ? '' : sortKey,
    dir: dirNum
  };
}

function filterChange() {
  searchQueryStore.initGeoSearch()
  searchQueryStore.setPagination(parseFilter(filter.value))
  handleSearchWithStore()
}

</script>

<style scoped
       lang="scss">
.filter-dropdown {
  @apply cursor-pointer;
  --el-select-input-focus-border-color: '#FFFFFF';
  --el-select-border-color-hover: '#FFFFFF';

  :deep(.el-select__wrapper) {
    @apply w-[168px];
    background-color: transparent;
    border-radius: 0;
    box-shadow: 0 0 0 0;
    padding: 0 8px;
  }

}


</style>
